import { ComponentPropsWithoutRef } from 'react';
import clsx from '../../../../../../helpers/clsx';

enum ETextSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  SuperLarge = 'SuperLarge',
}

type SectionTitleProps = ComponentPropsWithoutRef<'div'> & {
  sectionName: string;
  textSize?: `${ETextSize}`;
};

const hashTextClass = {
  [ETextSize.Large]:
    'text-[32px] font-semibold leading-[120%] tracking-[-0.4px]',
  [ETextSize.Medium]: 'text-2xl font-medium leading-[120%] tracking-[-0.25px]',
  [ETextSize.Small]: 'text-base font-medium leading-[150%] tracking-[-0.1px]',
  [ETextSize.SuperLarge]:
    'text-[50px] font-semibold leading-[140%] tracking-[-0.4px]',
};

const SectionTitle = (props: SectionTitleProps) => {
  const { sectionName, textSize, className } = props;

  return (
    <p className={clsx(hashTextClass[textSize || ETextSize.Large], className)}>
      {sectionName}
    </p>
  );
};

export default SectionTitle;
